import Primary from '@material-ui/icons/Star';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import styles from './index.css';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const PrimaryQuoteInfoIcon = ({ row }) => {
    const primaryQuote = row.primaryQuote;
    return (
        primaryQuote &&
        <Tooltip
            className={styles.tooltip}
            enterTouchDelay={0}
            title={
                <span style={{ fontSize: 16 }}>
                    <FormattedMessage id={'labels.PRIMARY_QUOTE'}></FormattedMessage>
                </span>
            }>
            <Primary fontSize='small' />
        </Tooltip>
    )
};

PrimaryQuoteInfoIcon.propTypes = {
    row: PropTypes.object.isRequired
};
